import {CursorBasedPaginationResponse, QueryBaseTypeWithCursorPaginationWhereAndOrder} from 'api/common';
import {UserInfoResponseModel} from 'models/userInfoFilter.model';

export interface TimeTrackerModel {
    id: string;
    userInfoId: string;
    userInfo?: UserInfoResponseModel;
    itemDataId?: string;
    sprintId?: string;
    tenantId: string;
    startTime: string;
    endTime?: string;
    title: string;
    description?: string;
    status: string;
    durationInSeconds: number;
    createdDate?: string;
    itemDataURL?: string;
    ticketNo?: number;
}
export interface TimeTrackerCreateUpdateRequest
    extends Omit<
        TimeTrackerModel,
        | 'id'
        | 'userInfoId'
        | 'tenantId'
        | 'durationInSeconds'
        | 'startTime'
        | 'endTime'
        | 'itemDataURL'
        | 'createdDate'
        | 'userInfo'
    > {
    startTime: Date | string;
    endTime?: Date | string;
    timeInput?: string; // HH:mm format
}
export interface TimeTracketFilters {
    itemDataId: string;
    sprintId: string;
    status: TimeTrackerStatus;
    id: string;
    userInfoId: string;
}
export interface TimeTrackerListingRequest extends QueryBaseTypeWithCursorPaginationWhereAndOrder<TimeTracketFilters> {}
export interface TimeTrackingListingRespone extends TimeTrackerModel {}
export interface TimeTrackerResponse extends TimeTrackerModel {}
export interface TimeTrackerListingPaginationResponse {
    allTimeTrackers: CursorBasedPaginationResponse<TimeTrackingListingRespone>;
}

export enum TimeTrackerStatus {
    Running = 'Running',
    Paused = 'Paused',
    Completed = 'Completed',
    Manual = 'Manual',
}
export const timeTrackerDefaultValues: TimeTrackerCreateUpdateRequest = {
    title: '',
    description: '',
    status: TimeTrackerStatus.Manual,
    startTime: new Date(),
    endTime: new Date(),
};
